import AbstractView from 'abstracts/AbstractView';
import Utils from 'utils/Utils';


export default new class MainLoader extends AbstractView {

	constructor() {
		super();
		this.needsToClose = true;
		this.previousWord = false;
		this.currentWord = 0;
	}


	set display(value) {
		if (value) {
			this.$mainLoader[0].style.display = '';
		} else
			this.$mainLoader[0].style.display = 'none';
	}


	initDOM() {
		this.$mainLoader = $(document.getElementById('main_loader'));
		this.$background = this.$mainLoader.find('.ml--background');
		this.$wordsWrapper = this.$mainLoader.find('.ml--words');
		this.$words = this.$wordsWrapper.children();
		this.numWords = this.$words.length;
		this.previousWord = this.numWords;
	}


	initEl() {
		gsap.set(this.$words, {y: 100, opacity: 0});
		this._nextWord();
	}

	_nextWord() {
		// Hide only
		if (this.needsToClose) {
			gsap.set(this.$background, {opacity: 0});

			gsap.timeline()
				.set(this.$words[this.currentWord], {
					opacity: 0,
					y: -100
				})
				.add(() => {
					this.needsToClose = false;
					this._onHideComplete();
				}, 0.5);
		}
		// Hide and show next
		else {
			this.previousWord = this.currentWord;
			this.currentWord = this.currentWord + 1;
			if (this.currentWord === this.numWords - 1) {
				this.currentWord = 0;
			}
			gsap.timeline()
				.set(this.$words[this.previousWord], {
					opacity: 0,
					y: -100,
				})
				.set(this.$words[this.currentWord], {
					opacity: 1,
					y: 0,
				}, 0.4)
				.set(this.$words[this.previousWord], {y: 100, opacity: 0}, 1)
				.add(() => {
					this._nextWord();
				}, 1)
		}
	}


	show(isFirstLoad) {
		this.display = true;
		this.df.show = Utils.Deferred();
		if (isFirstLoad) {
			this._onShowComplete();
		} else {
			this._nextWord();
			this.tl.show = gsap.timeline({
				onComplete: this._onShowComplete.bind(this)
			})
				.set(this.$background, {opacity: 1}, 0)
				.add(() => {
				}, 0.5);
		}
		return this.df.show.promise;
	}


	_onShowComplete() {
		this.df.show.resolve();
	}


	// isFirstLoad/transState can be used if we need a different transition on first screen
	hide(isFirstLoad, transState = null) {
		this.df.hide = Utils.Deferred();

		if (isFirstLoad) {
			this.needsToClose = true;
			this._onHideComplete();
			return this.df.hide.promise;
		}

		if (this.tl.show && this.tl.show.isActive()) {
			this.tl.show.eventCallback("onComplete", () => {
				this.tl.show.eventCallback("onComplete", null);
				this.needsToClose = true;
			});
		} else {
			this.needsToClose = true;
		}
		return this.df.hide.promise;
	}


	_onHideComplete(isFirstLoad) {
		this.display = false;
		this.df.hide.resolve();
	}

};

